export { I18nProvider, useI18n, getCurrentLocale } from './I18nProvider'
